<template>
  <div class="py-2">
    <prismic-link :field="link">
      <div class="inline-flex items-center bg-white leading-none text-fuchsia-800 hover:bg-fuchsia-50 rounded-xl px-5 py-4 text-md">
        <span class="inline-flex pr-2">
          <prismic-rich-text :field="title" />
        </span>
          <!-- <div style="text-bold">&#x2197;</div>  -->
        <img class="fill-current" src=" data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAYAAACNMs+9AAAAQElEQVR42qXKwQkAIAxDUUdxtO6/RBQkQZvSi8I/pL4BoGw/XPkh4XigPmsUgh0626AjRsgxHTkUThsG2T/sIlzdTsp52kSS1wAAAABJRU5ErkJggg== " alt="" />
        <!-- <ButtonMore /> -->
      </div>
    </prismic-link>
  </div>
</template>

<script>
import ButtonMore from './ButtonMore.vue'
export default {
    name: 'ReferenceButton',
    components:{
        ButtonMore
    },
  props: {
    title: Array,
    link: Object
  }
}
</script>
